export const TIME_OFF_CALENDAR_HUB_PATH = '/hubs/time-off-calendar';

export const TIME_OFF_CALENDAR_CHANGED_EVENT = 'CalendarChanged';

export interface TimeOffCalendarChangedNotice {
  reason: string;
  changedAtUtc: string;
  runId?: string | null;
  entryId?: string | null;
}

export function normalizeTimeOffCalendarChangedNotice(raw: unknown): TimeOffCalendarChangedNotice {
  const r = (typeof raw === 'object' && raw != null ? raw : {}) as Record<string, unknown>;
  const runId = r.runId ?? r.RunId;
  const entryId = r.entryId ?? r.EntryId;
  return {
    reason: String(r.reason ?? r.Reason ?? ''),
    changedAtUtc: String(r.changedAtUtc ?? r.ChangedAtUtc ?? ''),
    runId: runId == null ? null : String(runId),
    entryId: entryId == null ? null : String(entryId)
  };
}

/** Fallback poll when SignalR is connected — catches missed pushes without frequent polling. */
export const TIME_OFF_CALENDAR_SIGNALR_FALLBACK_POLL_MS = 5 * 60_000;

/** Coalesce burst notifications (e.g. sync reconcile) into one silent refresh. */
export const TIME_OFF_CALENDAR_REALTIME_DEBOUNCE_MS = 750;
